module.exports = [
	{
		"title": "Introducing Urban Decals",
		"description": "Have some creative fun making urban environments with these new scans of street potholes, markings, cracks, patches, manhole covers and more.",
		"tags": "decals",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/Urban_Banner_0.jpg"
	},
	{
		"title": "Valley",
		"description": "A varied set of forest assets for creating lush woodland scenes. Combine mossy rocks, assemblies, logs and wood elements to create rich natural environments.",
		"pack": "valley",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/Valley_Banner_4480x960.jpg"
	},
	{
		"title": "Stump",
		"description": "Add detail to your forest scene with a selection of stumps, iconic mushrooms, fungi, moss, leaves, and scatter debris.",
		"pack": "stump",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/StumpBanner_4480x960.jpg"
	},
	{
		"title": "Quarry",
		"description": "Beautiful colored rock and cliffs with sharp, chiseled features make an awesome set from an undisturbed abandoned quarry we found in the outback.",
		"pack": "quarry",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/Quarry_4480x960.jpg"
	},
	{
		"title": "Lava Field",
		"description": "A huge set of rugged Lava Field assets, including rocks, cliffs, slabs, plants and rubble for creating dramatic desolate scenes on a large scale.",
		"pack": "lava-field",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/LavaField_4480x960.jpg"
	},
	{
		"title": "Ocean",
		"description": "Create underwater scenes of incredible realism with this set of ocean assets. From seaweed to shells, this collection encompasses a wide variety of subjects from marine ecosystems.",
		"pack": "ocean",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/Ocean_Banner_Wide_Retina.jpg"
	},
	{
		"title": "Pine Essentials",
		"description": "Create a detailed scene with this essential collection of fallen logs buried in beds of pine needles, supported by tree stumps and scatter assets.",
		"pack": "pine-essentials",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/PineBanner_4480x960.jpg"
	},
	{
		"title": "Dry Grassland",
		"description": "Hundreds of specimens curated into a set of 60+ Dry grassland assets, covering everything from sticks, leaves, dry grasses and bleached wood.",
		"pack": "dry-grassland",
		"image": "https://d3uwib8iif8w1p.cloudfront.net/megascans/pack-banners/Drygrassland_4480x960.jpg"
	}
]


//////////////////
// WEBPACK FOOTER
// ./src/data/ads/ads.json
// module id = 2454
// module chunks = 0